import { EducationalContent } from './EducationalContent';

interface Props {
  briefType: string | undefined;
}

export const BriefEducationalContent = ({ briefType }: Props) => {
  switch (briefType) {
    case 'HasReportedEarnings':
      return (
        <EducationalContent
          title="Earning Updates"
          content="Understand a company’s latest earnings figures, how they compares to prior periods and how to interpret the trends."
          link="https://www.youtube.com/watch?v=v9Y_Ebht1LM&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT"
        />
      );
    case 'ValuationUpdateWith7DayPriceMove':
      return (
        <EducationalContent
          title="Valuation Updates"
          content="Understand how to interpret a company’s valuation metrics after a significant price movement, and how it compares to its peers."
          link="https://www.youtube.com/watch?v=hPsIUEr1JU0&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=2"
        />
      );
    case 'HasExecutiveDeparture':
      return (
        <EducationalContent
          title="Executive Departures"
          content="Understand how to interpret a company’s valuation metrics after a significant price movement, and how it compares to its peers."
          link="https://www.youtube.com/watch?v=0S0KIDLWfNU&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=3"
        />
      );
    case 'HasRecentInsiderTransactions':
      return (
        <EducationalContent
          title="Insider Transactions"
          content="Understand how to interpret recent buys or sells from insiders, and where to get more context on the transactions."
          link="https://www.youtube.com/watch?v=dibKz9dymhw&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=4"
        />
      );
    case 'HasUpcomingDividend':
      return (
        <EducationalContent
          title="Upcoming Dividends"
          content="Understand a company’s dividend metrics, and whether it’s the most attractive in the market, or if there are better opportunities."
          link="https://www.youtube.com/watch?v=YoPkVqRTXaI&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=5"
        />
      );
    case 'HasPriceTargetChanged':
      return (
        <EducationalContent
          title="Analysts Price Targets"
          content="Understand what developments drove analysts to update their price target for a stock, and if this provides an opportunity or risk."
          link="https://www.youtube.com/watch?v=FrmBkgFzTck&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=6"
        />
      );
    case 'HasMajorEstimateRevision':
      return (
        <EducationalContent
          title="Price Target revisions"
          content="Understand why consensus estimates from analysts have changed, how this compares to expected peers performance and learn how the market interpreted the change."
          link="https://www.youtube.com/watch?v=1Eolor_di08&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=9"
        />
      );
    case 'HasBreakevenDateChange':
      return (
        <EducationalContent
          title="Breakeven changes"
          content="Understand what’s required for a company’s expected breakeven date to come true, and learn how to decide if this seems reasonable."
          link="https://www.youtube.com/watch?v=5PvsAkhH5Nw&list=PLVdrK24l-IHfHaih5wmYOgnrMEPqCNtkT&index=7"
        />
      );
    case 'IsMergerAcquisitionTarget':
      return (
        <EducationalContent
          title="Mergers and Acquisitions"
          content="Understand what an acquisition means for a company, and what effects is may have on your investment."
          link="https://youtu.be/JV8vA4XunX4?t=317"
        />
      );
  }
  return null;
};
